import timezones from './timezone_list.json';

type UTCTz = {
    name: string;
    abbr: string;
    offset: number;
    fullName: string;
    isdst: boolean;
};

function getTimezones() {
    const utcTzs: { [key: string]: UTCTz } = {};

    for (const tz of timezones) {
        if (!tz.utc || !tz.utc.length) continue;

        for (const utc of tz.utc) {
            utcTzs[utc] = {
                name: tz.value,
                abbr: tz.abbr,
                offset: tz.offset,
                fullName: tz.text,
                isdst: tz.isdst,
            };
        }
    }

    return utcTzs;
}

const Timezones = getTimezones();

export default Timezones;